const devicesEN = {
  // namespace your translation keys with "devices", i.e.
  // 'devices.lorem_ipsum': 'Lorem Ipsum'
  'devices.devices': 'Devices',
  'devices.device-setup': 'Device Setup',
  'devices.prep-stations': 'Prep Stations',
  'devices.prep-station.name': 'Prep Station Name',
  'devices.prep-station.create': 'Create Prep Station',
  'devices.prep-station.edit': 'Edit Prep Station',
  'devices.prep-station.bulk-update':
    'Prep station changes will add to the existing setup for all selected items.',
  'devices.prep-station.delete_modal.title':
    "Are you sure you want to delete the prep station named '{{label}}'?",
  'devices.prep-station.delete': 'Delete Prep Station',
  'devices.prep-station.delete.message': "'{{label}}' has been deleted from your prep stations",
  'devices.prep-station.configured-on-the-pos': 'Printers must be configured on the POS',
  'devices.prep-station.explanation':
    'Prep Stations manage how printers are organized and where tickets are printed in your restaurant. Prep stations can house one or more printers. Common prep stations include: drinks, food, and no print. Once your prep stations have been created and you have assigned printers to their respective prep stations through the POS app, you can send tickets to be printed.',
  'devices.prep-station.is_required': 'Prep Station Name is required',
  'devices.view_details': 'View Details',
  'devices.link-device': 'Connect Main Device',
  'devices.link-device-reservations': 'Connect Device',
  'devices.link-modal-descriptions.0':
    'Your Main Device will link your POS to your Restaurant in Cloud, allowing you to manage your restaurant and view reports from anywhere. If your main device is an iPad, install TouchBistro POS from the App Store, tap Setup My Restaurant, and then select Main Device.',
  'devices.link-modal-descriptions.1':
    'If your main device is a Mac, <1>download</1> and install TouchBistro Pro Server.',
  'devices.link-modal-descriptions.2':
    'Enter the device code or scan the QR code to connect the Main Device to your restaurant.',
  'devices.link-modal-descriptions-reservations.0':
    'Your Device will link TouchBistro Reservations to your Restaurant in Cloud, allowing you to manage your bookings from anywhere.',
  'devices.link-modal-descriptions-reservations.1':
    'On your iPad, install TouchBistro Reservations from the app store, tap “Connect This Device”, then enter this device code or scan this QR code to connect the device.',
  'devices.link-main-android-device': 'Link Main Device',
  'devices.link-main-android-device-description':
    'Use this code to link your Main Device to your restaurant in TouchBistro Cloud. There is only one main device per location.',
  'devices.relink-main-android-device': 'Re-Authenticate Main Device',
  'devices.relink-main-android-device-description':
    'Use this code to re-link your Main Device to your restaurant in TouchBistro Cloud. There is only one main device per location.',
  'devices.link-android-device-code-label': 'Enter the following code on your device',
  'devices.relink-device': 'Re-Authenticate Device',
  'devices.relink-android-device': 'Re-Authenticate Main Device',
  'devices.relink-device-reservations': 'Re-Authenticate Device',
  'devices.relink-modal-descriptions.0':
    'A new code has been generated to re-authenticate your Main Device, and link your POS to your Restaurant in the Cloud. Allowing you to continue managing your restaurant and view reports from anywhere.',
  'devices.relink-modal-descriptions.1':
    'If your main device is an iPad, in Admin Settings, go to Re-authenticate, log-in to your Cloud account, then enter the Device Code or Scan QR Code, provided below.',
  'devices.relink-modal-descriptions.2':
    'If your main device is a Mac, go to Touchbistro Pro Server in the menu bar, and choose Re-authenticate, then enter the Device Code, provided below.',
  'devices.expire_timer': 'This code will expire in',
  'devices.link-android-device-expire-timer': 'This code will expire in',
  'devices.link-android-device-refresh': 'Refresh',
  'devices.peripheral-setup': 'Peripheral Setup',
  'devices.peripheral_setup.empty_landing_text':
    "Your Restaurant doesn't have any connected peripherals.<br />First setup peripherals on your POS to manage them here.",
  'devices.receipt_printer': 'Receipt Printer',
  'devices.kitchen_printer': 'Kitchen Printer',
  'devices.kds': 'KDS',
  'devices.select_prep_stations': 'Select prep stations',
  'devices.no_prep_stations_available': 'No stations available',
  'devices.select_prep_stations.helper': 'Selected prep stations send items to this printer',
  'devices.peripheral_details': 'Peripheral Details',
  'devices.back_to_peripheral_setup': 'Back to Peripheral Setup',
  'devices.device_name': 'Device Name',
  'devices.device_name_max_length': 'Device Name must be {{limit}} characters or fewer',
  'devices.device_name_max_length_helper': 'Maximum {{limit}} characters',
  'devices.printer_type': 'Printer Type',
  'devices.printer_model': 'Printer Model',
  'devices.ip_address': 'IP Address',
  'devices.cash_drawer': 'Cash Drawer',
  'devices.last_updated': 'Last Updated',
  'devices.back-to-setup': 'Back to Device Setup',
  'devices.device_model': 'Device Model',
  'devices.device_id': 'Device ID',
  'devices.pos_version': 'POS Version',
  'devices.host_app_version': 'Host App Version',
  'devices.os_version': 'OS Version',
  'devices.last_connected': 'Last Connected',
  'devices.connect_device_for_doordash_online_ordering_title':
    'Connect Main Device to your Restaurant for DoorDash Online Ordering',
  'devices.connect_device_for_doordash_online_ordering_subtitle':
    "Configure your devices for DoorDash Online Ordering Integration. After you've finished, please save your changes and continue the setup process.",
}

export default devicesEN
